import { configureStore } from '@reduxjs/toolkit'
import explorerReducer from '../state/explorer/explorerSlice'
import locationReducer from '../state/locations/locationSlice'
import profileReducer from '../state/profile/profileSlice'
import searchReducer from '../state/search/searchSlice'
import albumsReducer from '../state/albums/albumsSlice'

export const store = configureStore({
  reducer: {
    explorer: explorerReducer,
    location: locationReducer,
    search: searchReducer,
    profile: profileReducer,
    albums: albumsReducer,
  }
})

// Get the type of our store variable
export type AppStore = typeof store
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = AppStore['dispatch']